import React from 'react';
import './styles.css';

export function NumberSelect({ selectedNumber, onSelect }) {
  const handleNumberChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    const newSelectedNumber = isNaN(newValue) || newValue < 0 ? 0 : newValue;

    onSelect(newSelectedNumber);
  };
  
  return (
      <input
        className="form-control"
        type="number"
        value={selectedNumber !== 0 ? selectedNumber : ''}
        onChange={handleNumberChange}
      />

  );
}
